/**
 * /tenants/$slug/identity-hygiene — route shim.
 *
 * Dormant-access dashboard. Filter state lives in URL search
 * params (chip selections, page index). The loader prefetches
 * page 1 with no filters so the initial render shows data
 * without a spinner.
 */

import { createFileRoute } from "@tanstack/react-router";
import { loadIdentityHygiene } from "@/features/identity-hygiene/loader";
import { dormantFilterSearchSchema } from "@/features/identity-hygiene/schemas";
import { IdentityHygienePage } from "@/features/identity-hygiene/pages/identity-hygiene-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/identity-hygiene/",
)({
  validateSearch: (raw: Record<string, unknown>) =>
    dormantFilterSearchSchema.parse(raw),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => loadIdentityHygiene(context.queryClient, context.tenant.id, deps, context.authority.permissions),
  component: IdentityHygienePage,
});
